import { useStore } from 'effector-react'
import * as React from 'react'

import { $error, $landing, getLanding, landingMounted } from './model'

export const useLanding = () => {
  const landing = useStore($landing)
  const error = useStore($error)

  const loading = useStore(getLanding.pending)

  React.useEffect(() => {
    landingMounted()
  }, [])

  return { landing, loading, error }
}
